import React from 'react'
import { CNavGroup, CNavItem } from '@coreui/react'

import _modules from '../../_modules'
import attendance_records from '../../collectionsStructure/hrm-attendance_records'
import expenses from '../../collectionsStructure/hrm-expenses'
import salaries from '../../collectionsStructure/hrm-salaries'
import salary_report from '../../collectionsStructure/hrm-salary_report'
import mpf_report from '../../collectionsStructure/hrm-mpf_report'
import benefits from '../../collectionsStructure/hrm-benefits'
import applications from '../../collectionsStructure/hrm-applications'
import warning_letters from '../../collectionsStructure/hrm-warning_letters'
import commendatory_letters from '../../collectionsStructure/hrm-commendatory_letters'
import promotion_letters from '../../collectionsStructure/hrm-promotion_letters'
import reference_letters from '../../collectionsStructure/hrm-reference_letters'
import staff_evaluations from '../../collectionsStructure/hrm-staff_evaluations'
import shifts from '../../collectionsStructure/hrm-shifts'

const hrm_items = {
  component: CNavGroup,
  name: 'HRM',
  icon: <i className="material-icons-outlined">manage_accounts</i>,
  items: [],
}
let output = []

if (
  _modules.attendance_records ||
  _modules.expenses ||
  _modules.salary ||
  _modules.salary_reports ||
  _modules.mpf_reports ||
  _modules.benefits ||
  _modules.applications ||
  _modules.shifts ||
  _modules.staff_evaluations
) {
  // add more items above with OR condition
  if (_modules.attendance_records)
    hrm_items.items.push({
      component: CNavItem,
      name: 'Attendance Records',
      to: '/attendance-records',
      permissionSource: attendance_records.permissionSource,
      icon: <i className="material-icons-outlined">how_to_reg</i>,
    })
  if (_modules.expenses)
    hrm_items.items.push({
      component: CNavItem,
      name: 'Expenses',
      to: '/expenses',
      permissionSource: expenses.permissionSource,
      icon: <i className="material-icons-outlined">incomplete_circle</i>,
    })
  if (_modules.salary)
    hrm_items.items.push({
      component: CNavItem,
      name: 'Salary',
      to: '/salary',
      permissionSource: salaries.permissionSource,
      icon: <i className="material-icons-outlined">monetization_on</i>,
    })
  if (_modules.salary_reports)
    hrm_items.items.push({
      component: CNavItem,
      name: 'Salary Report',
      to: '/salary-reports',
      permissionSource: salary_report.permissionSource,
      icon: <i className="material-icons-outlined">monetization_on</i>,
    })
  if (_modules.mpf_reports)
    hrm_items.items.push({
      component: CNavItem,
      name: 'MPF Report',
      to: '/mpf-reports',
      permissionSource: mpf_report.permissionSource,
      icon: <i className="material-icons-outlined">monetization_on</i>,
    })
  if (_modules.benefits)
    hrm_items.items.push({
      component: CNavItem,
      name: 'Benefits',
      to: '/benefits',
      permissionSource: benefits.permissionSource,
      icon: <i className="material-icons-outlined">mood</i>,
    })
  if (_modules.applications)
    hrm_items.items.push({
      component: CNavItem,
      name: 'Applications',
      to: '/applications',
      permissionSource: applications.permissionSource,
      icon: <i className="material-icons-outlined">mood</i>,
    })
  if (_modules.warning_letters)
    hrm_items.items.push({
      component: CNavItem,
      name: 'Warning Letters',
      to: '/warning-letters',
      permissionSource: warning_letters.permissionSource,
      icon: <i className="material-icons-outlined">feedback</i>,
    })
  if (_modules.commendatory_letters)
    hrm_items.items.push({
      component: CNavItem,
      name: 'Commendatory Letters',
      to: '/commendatory-letters',
      permissionSource: commendatory_letters.permissionSource,
      icon: <i className="material-icons-outlined">feedback</i>,
    })
  if (_modules.promotion_letters)
    hrm_items.items.push({
      component: CNavItem,
      name: 'Promotion Letters',
      to: '/promotion-letters',
      permissionSource: promotion_letters.permissionSource,
      icon: <i className="material-icons-outlined">feedback</i>,
    })
  if (_modules.reference_letters)
    hrm_items.items.push({
      component: CNavItem,
      name: 'Reference Letters',
      to: '/reference-letters',
      permissionSource: reference_letters.permissionSource,
      icon: <i className="material-icons-outlined">feedback</i>,
    })
  if (_modules.staff_evaluations)
    hrm_items.items.push({
      component: CNavItem,
      name: 'Staff Evaluations',
      to: '/staff-evaluations',
      permissionSource: staff_evaluations.permissionSource,
      icon: <i className="material-icons-outlined">feedback</i>,
    })
  if (_modules.shifts)
    hrm_items.items.push({
      component: CNavItem,
      name: 'Shifts',
      to: '/shifts',
      permissionSource: shifts.permissionSource,
      icon: <i className="material-icons-outlined">feedback</i>,
    })

  output.push(hrm_items)
}

export default output
